import url from '../../../config/urls';
import axiosActionsFactory from '../axiosActionsFactory';
import localStorageFacade, { LocalStorageKeys } from '../../../utils/localStorageFacade';

export const UserActionsTypes = {
  GOOGLE_AUTH: axiosActionsFactory('GOOGLE_AUTH'),
  BASIC_AUTH: axiosActionsFactory('BASIC_AUTH'),
  CHECK_AUTH: axiosActionsFactory('CHECK_AUTH'),
  LOGOUT: 'LOGOUT',
};

const googleAuth = ({ token }) => (dispatch) => {
  localStorageFacade.put(LocalStorageKeys.AUTH_TOKEN, `Bearer ${token}`);
  return dispatch({
    type: UserActionsTypes.GOOGLE_AUTH.START,
    payload: {
      request: {
        method: 'post',
        url: url.auth(),
      },
    },
  });
};

const basicAuth = ({ login, password }) => (dispatch) => {
  const token = btoa(`${login}:${password}`);
  localStorageFacade.put(LocalStorageKeys.AUTH_TOKEN, `Basic ${token}`);
  return dispatch({
    type: UserActionsTypes.BASIC_AUTH.START,
    payload: {
      request: {
        method: 'post',
        url: url.auth(),
      },
    },
  });
};

const checkAuth = () => (dispatch) => dispatch({
  type: UserActionsTypes.BASIC_AUTH.START,
  payload: {
    request: {
      method: 'post',
      url: url.auth(),
    },
  },
});

const logout = () => ({
  type: UserActionsTypes.LOGOUT,
});

export const AuthActions = {
  googleAuth,
  basicAuth,
  checkAuth,
  logout,
};
